import { GradeBand } from "./gradeBand.model"

export const SUGGESTED_SCHOOL_ID = -1

export const PBSLM_TITLE = "PBS LearningMedia"

export enum GradeBandEnum {
    BandPreKtoK = "PreK-K",
    BandKto2 = "K-2",
    Band3to5 = "3-5",
    Band6to8 = "6-8",
    Band9to12 = "9-12",
    Band13Plus = "13+",
}

export const ORDERED_GRADE_KEYS = [
    GradeBandEnum.BandPreKtoK,
    GradeBandEnum.BandKto2,
    GradeBandEnum.Band3to5,
    GradeBandEnum.Band6to8,
    GradeBandEnum.Band9to12,
]

export const GRADE_BANDS: GradeBand[] = [
    {
        gtmLabel: GradeBandEnum.BandPreKtoK,
        label: GradeBandEnum.BandPreKtoK,
        uri: GradeBandEnum.BandPreKtoK,
        description:
            "Find early learning resources for preschool and kindergarten that support the critical transition to school.  Inspire your students with videos, games, and activities aligned to state and national standards.",
        metaTitle: "Early Learning Resources for PreK and K",
    },
    {
        gtmLabel: GradeBandEnum.BandKto2,
        label: GradeBandEnum.BandKto2,
        uri: GradeBandEnum.BandKto2,
        description:
            "Find early elementary resources and lessons. Inspire your students with videos, games, and activities aligned to state and national standards.",
        metaTitle: "Elementary Resources For K to 2",
    },
    {
        gtmLabel: GradeBandEnum.Band3to5,
        label: GradeBandEnum.Band3to5,
        uri: GradeBandEnum.Band3to5,
        description:
            "Find elementary resources and lessons. Inspire your students with videos, games, and activities aligned to state and national standards.",
        metaTitle: "Elementary Resources For 3 to 5",
    },
    {
        gtmLabel: GradeBandEnum.Band6to8,
        label: GradeBandEnum.Band6to8,
        uri: GradeBandEnum.Band6to8,
        description:
            "Find resources for middle school learners. Inspire your students with videos, games, and activities aligned to state and national standards.",
        metaTitle: "Resources For Middle School Lesson Plans",
    },
    {
        gtmLabel: GradeBandEnum.Band9to12,
        label: GradeBandEnum.Band9to12,
        uri: GradeBandEnum.Band9to12,
        description:
            "Find resources and activities for high school learners. Inspire your students with videos, games, and activities aligned to state and national standards.",
        metaTitle: "Resources For High School Lesson Plans",
    },
]

export const DeprecatedGradeURImap = {
    prek: GradeBandEnum.BandPreKtoK,
    "early-elementary": GradeBandEnum.BandKto2,
    "upper-elementary": GradeBandEnum.Band3to5,
    "middle-school": GradeBandEnum.Band6to8,
    "high-school": GradeBandEnum.Band9to12,
}

export const ORDERED_MEDIA_TYPES = [
    "Collection",
    "Video",
    "Interactive Lesson",
    "Interactive",
    "Lesson Plan",
    "Media Gallery",
    "Audio",
    "Image",
    "Document",
    "Webpage",
]

export const ALIASED_FACETS = ["cp", "cs", "ct", "subject"]

export const CH_FACET_ID = "ch"
